import {SaleChannelService} from "../resource";

const SaleChannelModule = {
	namespaced: true,
	state: {
		datas: [],
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		}
	},
	actions: {
		createData({ commit, state }, params) {
			return SaleChannelService.SaleChannelCreate(params);
		},

		updateData({ commit, state }, params) {
			return SaleChannelService.SaleChannelUpdate(params.id,params.payload);
		},

		deleteData({ commit, state }, params) {
			return SaleChannelService.SaleChannelDelete(params);
		},

		async listData({ commit, state }, params) {
			try
			{
				const response = await SaleChannelService.SaleChannelList(params);
				commit("SET_DATA", response.data.Data);
			}
			catch (error)
			{
				commit("SET_DATA", []);
			}
		}
	},
	getters: {
		getData(state) {
			return state.datas;
		},
		getDataWithAll(state) {
			return  [
				{id:0,name:"--- ช่องทางการขาย --- "},...state.datas ];
		},
		getDataTypeWithAll(state) {
			return  [
				{id:0,name:"--- ประเภทช่องทางการขาย --- "},
				{id:1,name:"บริษัท"},
				{id:2,name:"ตัวแทน"},
			 ];

		}
	},
};

export default SaleChannelModule;